import { render, staticRenderFns } from "./wrap.vue?vue&type=template&id=65478fae&scoped=true"
import script from "./wrap.vue?vue&type=script&lang=js"
export * from "./wrap.vue?vue&type=script&lang=js"
import style0 from "./wrap.vue?vue&type=style&index=0&id=65478fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65478fae",
  null
  
)

export default component.exports